<template>
  <div
    v-if="isLoad"
    class="box-placeholder"
  >
    <div class="text" v-for="i in loops" :key="i.toString()" :id="i" />
  </div>
</template>

<script lang="js">
export default {
  props: {
    isLoad: {
      type: Boolean,
      default: false
    },
    line: {
      type: Number,
      default: 9
    }
  },
  computed: {
    loops() {
      return [...Array(this.line).keys()]
    }
  }
}
</script>